import { trpc } from '../trpc'

export function useSubscribe() {
  return trpc.pushSubscription.subscribe.useMutation()
}

export function useUnsubscribe() {
  return trpc.pushSubscription.unsubscribe.useMutation()
}

export function useGetVapidPublicKey() {
  return trpc.pushSubscription.getVapidPublicKey.useQuery()
}
